import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import JobDTO from '@src/adapters/dto/job/JobDTO';
import JobSelectionItem from './JobSelectionItem';
import { isBetween } from '@src/utils/dateUtils';
import { useState } from 'react';

interface Props {
  jobs: JobDTO[];
  onJobSelected(jobId: string): void;
  roles: string[];
  date: Date;
}

function JobSelection({ jobs, onJobSelected, roles, date }: Props) {
  const [job, setJob] = useState('');

  const jobSelected = (event: SelectChangeEvent) => {
    setJob(event.target.value as string);
    onJobSelected(event.target.value);
  };

  const filteredJobs = jobs.filter(
    (job) =>
      job.role &&
      roles.includes(job.role.id!) &&
      isBetween(date, job.startDate!, job.endDate!)
  );

  return (
    <>
      {filteredJobs.length > 0 && (
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={job}
          renderValue={(selected) => {
            const job = jobs.find((j) => j.id === selected);
            return job ? job.shortName.toUpperCase() : '';
          }}
          sx={(theme) => ({
            color: 'rgba(255, 255, 255, 0.5)',
            border: '1px solid #444445',
            width: '118px',
            height: '40px',
            '& .MuiSelect-icon': {
              color: '#ffffff',
            },
            '& .Mui-focused': {
              color: '#ffffff',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#444445',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ffffff',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ffffff',
            },
          })}
          onChange={jobSelected}>
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {filteredJobs.map((job) => (
            <MenuItem key={job.id} value={job.id}>
              <JobSelectionItem job={job} />
            </MenuItem>
          ))}
        </Select>
      )}
    </>
  );
}

export default JobSelection;
